import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import "./PortfolioImage.css";
import "./PortfolioImageCarousel.css";
import Constants from "../Constants";
import { TimelineLite, TweenLite, Power0, Power2 } from "gsap";

import iconVR from "../img/icon-vr.svg";
// import iconWebGL from "../img/icon-webgl.svg";

class PortfolioImageCarousel extends Component {
	constructor() {
		super();

		// console.log(`PortfolioImageCarousel`);
		window.addEventListener("resize", this.handleWindowResize);
	}

	handleWindowResize = () => {
		// console.log(`window resize`);
		if (window.innerWidth !== this.state.innerWidth) {
			this.setState({ innerWidth: window.innerWidth });
		}
	};

	state = {
		dur: 1.5,
		delay: 3,
		navigate: false,
		innerWidth: window.innerWidth,
	};

	handleClick = event => {
		this.setState({ navigate: true });
	};

	getIcon = type => {
		let src;

		// switch (type) {
		// 	case Constants.TYPE_WEBGL:
		// 		src = iconWebGL;
		// 		break;

		// 	default:
		// 		src = iconVR;
		// 		break;
		// }

		if (type === Constants.TYPE_VR) {
			src = iconVR;
			return (
				<img className="IconType" src={src} alt={`Icon of type ${type}`} />
			);
		}

		return;
	};

	componentWillUnmount = () => {
		// console.log(`componentWillUnmount`);
		window.removeEventListener("resize", this.handleWindowResize);
		this.timeline.kill();
	};

	componentDidMount = () => {
		// console.log(`componentDidMount`, this.cube);
		this.resetCube();
		this.rotateCube(
			this.props.index * 0.5 +
				this.props.total * Constants.ANIMATION_INTERVAL_DELAY +
				1
		);
		this.fadeIn();
	};

	componentDidUpdate = prevProps => {
		if (
			prevProps.labelsVisible === this.props.labelsVisible &&
			this.state.navigate === false
		) {
			// console.log(`componentDidUpdate`, this.cube);
			this.timeline.kill();
			this.resetCube();
			this.rotateCube(
				this.props.index * 0.5 +
					this.props.total * Constants.ANIMATION_INTERVAL_DELAY +
					1
			);
			// Fade in
			TweenLite.set(this.portfolioImage, { opacity: 0 });
			this.fadeIn();
		}
	};

	fadeIn = () => {
		TweenLite.to(this.portfolioImage, 0.5, {
			opacity: 1,
			ease: Power0.easeInOut,
			delay: this.props.indexAll * Constants.ANIMATION_INTERVAL_DELAY,
		});
	};

	rotateCube = (delay = 0) => {
		const inFr = 6 / 10;
		const outFr = 1 - inFr;

		this.timeline = new TimelineLite({
			onComplete: this.rotateCube,
			onCompleteParams: [this.state.delay],
			delay,
		});

		// Rotation
		this.timeline.to(
			this.cube,
			this.state.dur * 0.5,
			{ rotationY: "-=90", ease: Power2.easeInOut },
			this.state.dur * 0.25
		);

		// Initial Z
		this.timeline.to(
			this.cube,
			this.state.dur * inFr,
			{ z: `-${this.cube.clientWidth * 2.5}px`, ease: Power0.easeInOut },
			0
		);

		// Secondary Z
		this.timeline.to(
			this.cube,
			this.state.dur * outFr,
			{ z: `-${this.cube.clientWidth / 2}px`, ease: Power2.easeInOut },
			this.state.dur * inFr
		);
	};

	resetCube = () => {
		TweenLite.set(this.cube, { z: `-${this.cube.clientWidth / 2}px` });
		TweenLite.set(this.cube, { rotationY: 0 });
	};

	render() {
		const { src, hero, type, name, id } = this.props.data;
		const { labelsVisible, indexAll } = this.props;

		if (this.state.navigate === true) {
			return <Redirect push to={`/${id}`} />;
		} else {
			return (
				<div
					onClick={this.handleClick}
					className={`PortfolioImage ${hero ? "Hero" : ""}`}
					ref={element => {
						this.portfolioImage = element;
					}}
				>
					<div
						className="Cube"
						ref={element => {
							this.cube = element;
						}}
					>
						{src.map((img, imgIndex) => {
							return (
								<div
									className={`Image Side${imgIndex}`}
									key={imgIndex}
									style={{
										backgroundImage: `url(${Constants.IMAGE_PATH_PREFIX +
											img})`,
									}}
								/>
							);
						})}
					</div>
					<div
						className={`Name ${labelsVisible === false ? "Hidden" : ""}`}
						style={{
							transitionDelay: `${Constants.ANIMATION_INTERVAL_DELAY *
								indexAll}s`,
						}}
					>
						{name}
					</div>
					{type !== "" && this.getIcon(type)}
				</div>
			);
		}
	}
}

export default PortfolioImageCarousel;



// WEBPACK FOOTER //
// ./src/components/PortfolioImageCarousel.js